import { action, observable } from 'mobx'

import Ds from './ds'

class Vendors {
  @observable data = []

  @observable ds = new Ds()

  @action loadAllVendors() {
    this.ds.query(`{ vendors(hash: "${ localStorage.getItem('userHash') }") { id name } }`, (data) => {
      this.data = data.vendors
    })
  }

  @action newVendor(name) {
    this.ds.query(`mutation { addVendor(name: "${ name }", hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllVendors()
    })
  }

  @action updateVendor(id, name) {
    this.ds.query(`mutation { updateVendor(id: ${ id }, name: "${ name }", hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllVendors()
    })
  }

  @action deleteVendor(id) {
    this.ds.query(`mutation { deleteVendor(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllVendors()
    })
  }
}

export default new Vendors



// WEBPACK FOOTER //
// ./src/stores/vendors.js